import { render } from "./CodeDiffViewer.vue?vue&type=template&id=59e9d89f"
import script from "./CodeDiffViewer.vue?vue&type=script&lang=js"
export * from "./CodeDiffViewer.vue?vue&type=script&lang=js"

import "./CodeDiffViewer.vue?vue&type=style&index=0&id=59e9d89f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__